import i18next, {ParseKeys} from "i18next";

// Libellé d'un rôle Keycloak. Les rôles sont dans `common:roles` et non dans `platform` : le menu
// et le sélecteur de rôles les affichent aussi, hors de l'écran utilisateurs. Un rôle que le front
// ne connaît pas encore s'affiche tel quel plutôt que sous la forme d'une clé de traduction ; le
// test de `roles.test.ts` vérifie qu'aucun rôle de `RolesTypes` n'en arrive là.
//
// `i18next.t` hors composant est voulu : la fonction sert aussi en dehors du rendu, et `t` lit la
// langue courante à chaque appel. Dans un composant, préférer `useTranslation`.
export const roleLabel = (role: string): string => {
  const key = `roles.${role}` as ParseKeys;
  return i18next.exists(key) ? i18next.t(key) : role;
};
